import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import { GuardProps } from 'types';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }: GuardProps) => {
    const { isLoggedIn, isInitialized } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!isLoggedIn && !isInitialized) {
            navigate('/login', {
                replace: true,
                state: {
                    from: `${location.pathname}${location.search}${location.hash}`
                }
            });
        }
    }, [isLoggedIn, isInitialized, navigate]);

    return children;
};

export default AuthGuard;
